import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/globalCss.css";


const modules = [
  {
    to: "/users",
    icon: "👥",
    title: "مدیریت کاربران",
    desc: "مشاهده، ویرایش و کنترل سطح دسترسی کاربران سامانه",
  },
  {
    to: "/tickets",
    icon: "🎫",
    title: "بررسی تیکت‌ها",
    desc: "پاسخ‌گویی و رسیدگی به درخواست‌های پشتیبانی",
  },
  {
    to: "/Orders",
    icon: "💰",
    title: "معاملات",
    desc: "نظارت بر سفارش‌های ثبت‌شده در سامانه",
  },
  {
    to: "/markets",
    icon: "🪙",
    title: "مدیریت بازارها",
    desc: "پیکربندی و فعال‌سازی بازارهای معاملاتی",
  },
  {
    to: "/station",
    icon: "🏆",
    title: "ایستگاه ثبت سفارش ادمین",
    desc: "ثبت دستی سفارش از سوی ادمین",
  },
  {
    to: "/settlements",
    icon: "💳",
    title: "مدیریت تسویه سفارشات",
    desc: "بررسی و تأیید تسویه‌های مالی",
  },
  
];

function Dashboard() {
  const navigate = useNavigate();
  const [now, setNow] = useState(new Date());
  const [adminName, setAdminName] = useState("مدیر سامانه");

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000 * 30);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const u = JSON.parse(raw);
        const name = u?.name || u?.fullName || u?.username;
        if (name) setAdminName(name);
      }
    } catch (e) {
      /* noop — fall back to default label */
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  const dateLabel = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(now);

  const timeLabel = new Intl.DateTimeFormat("fa-IR", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(now);

  return (
    <div className="gd-root" dir="rtl">
      
      <header className="gd-header">
        <div>
          <div className="gd-eyebrow">پنل مدیریت</div>
          <h1 className="gd-title">سامانه معاملات اعتباری طلای آرمانی</h1>
          <p className="gd-subtitle">کنترل و نظارت بر تمامی بخش‌های سامانه</p>
        </div>

        <div className="gd-side">
          <button onClick={handleLogout} className="gd-logout">
            <span aria-hidden="true">🚪</span>
            خروج
          </button>
          <div className="gd-status">
            <div className="gd-admin">
              <span className="gd-admin-dot" aria-hidden="true" />
              {adminName}
            </div>
            <div><strong>{dateLabel}</strong></div>
            <div>ساعت {timeLabel}</div>
          </div>
        </div>
      </header>

      <nav className="gd-grid" aria-label="بخش‌های مدیریتی">
        {modules.map((m) => (
          <Link to={m.to} className="gd-card" key={m.to}>
            <div className="gd-medallion" aria-hidden="true">{m.icon}</div>
            <h2 className="gd-card-title">{m.title}</h2>
            <p className="gd-card-desc">{m.desc}</p>
            <span className="gd-arrow">ورود ←</span>
          </Link>
        ))}
      </nav>
    </div>
  );
}

export default Dashboard;
